var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"p-0":""}},[_c('v-row',{staticClass:"my-0"},[_c('v-col',{staticClass:"pt-0 pb-0 my-0",attrs:{"cols":"12"}},[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('LoggedArea.News.Title')))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }